import styled from 'styled-components';
import { Link as RouteLink } from 'react-router-dom';
import { Header } from 'antd/lib/layout/layout';
import { BellOutlined, GlobalOutlined } from '@ant-design/icons';
import { Divider, Space, Card } from 'antd';

export const StyledHeader = styled(Header)`
  display: flex;
  justify-content: space-between;
  // background-color: transparent;
  background-color: #fff;
  padding: 0 1rem;
  height: 98px;
`;

export const Link = styled(RouteLink)`
  display: block;
`;

export const MenuWrapper = styled(Space)<{ lg?: boolean }>`
  display: flex;
  align-items: center;
`;

export const StyledDivider = styled(Divider)`
  margin: 0 16px;
  height: 32px;
`;

export const BravoGlobeIcon = styled(GlobalOutlined)`
  color: var(--primary-color);
`;
export const BravoGlobeIconGrey = styled(GlobalOutlined)`
  color: #20252b;
`;
export const BravoBellIcon = styled(BellOutlined)`
  color: var(--primary-color);
`;
interface StyledWrapperProps {
  isLogin?: boolean;
}

export const StyledWrapper = styled.div<StyledWrapperProps>`
  z-index: 120;
  position: relative;
  height: 98px;
  background-color: ${({ isLogin }) => (isLogin ? 'transparent' : '#fff')};
`;

export const DropCard = styled(Card)`
  position: absolute;
  width: 100%;
  z-index: 99;
  min-height: 154px;
`;

export const CardStyledDivider = styled(Divider)`
  margin: 0 10px;
  height: 80px;
`;

export const BriefWrapper = styled.div`
  width: 16.67%;
  text-align: center;
  padding: 10px;
`;
